import { RawInput, Validation } from '@ps/web-shared-components';
import React from 'react';
import { useIntl } from 'react-intl';

import SearchIcon from '@swf/core/assets/icons/icon-search.svg';
import { SEARCH_FILTER_COLUMN_ID } from '@swf/poker';

import { usePokerMultiTableTournamentsWidget } from '../../../../model';

import { TXTCLI_Search_tournaments } from './SearchInput.messages.json';
import styles from './SearchInput.scss';

const SearchInput: React.FC = () => {
  const { widgetDispatch } = usePokerMultiTableTournamentsWidget();
  const { formatMessage } = useIntl();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    widgetDispatch.setTableFilters([{ id: SEARCH_FILTER_COLUMN_ID, value: e.target.value }]);

  return (
    <RawInput
      id="tournament-search"
      label={TXTCLI_Search_tournaments}
      autoComplete="off"
      validationVariant={Validation.Invisible}
      hideLabel
      icon={SearchIcon}
      startAdornment="icon"
      onChange={handleOnChange}
      className={styles.searchInput}
      placeholder={formatMessage(TXTCLI_Search_tournaments)}
    />
  );
};

export default SearchInput;
